import { useId } from 'react';
import type { ProviderNetworkSettings } from '../../api/types';
import { strings } from '../../strings';

const t = strings.networks.topology;

/**
 * AWS outbound internet while the firewall doesn't filter egress (feature spec 17, phase 4; spec 11 6.15.31): a NAT
 * gateway only in a spoke whose apps need one (the default), or public subnets without one.
 */
export function OutboundInternet({
  value,
  readOnly,
  onChange,
}: {
  value: ProviderNetworkSettings['egress'];
  readOnly: boolean;
  onChange: (egress: 'nat-per-attachment' | 'public-subnets') => void;
}) {
  const name = useId();
  const chosen = value ?? 'nat-per-attachment';
  return (
    <fieldset className="sm:col-span-2" data-testid="aws-outbound-internet">
      <legend className="label">{t.outboundInternet}</legend>
      {(
        [
          ['nat-per-attachment', t.outboundNat, t.outboundNatHelp],
          ['public-subnets', t.outboundPublic, t.outboundPublicHelp],
        ] as const
      ).map(([v, label, help]) => (
        <label key={v} className="mb-1 flex items-start gap-2 text-sm">
          <input
            type="radio"
            name={name}
            className="mt-1"
            checked={chosen === v}
            disabled={readOnly}
            onChange={() => onChange(v)}
          />
          <span>
            <span className="font-medium">{label}</span>
            <span className="block text-[12.5px] text-fg-muted">{help}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
